import { useMemo } from 'react';
import { sortBy, keyBy, } from 'lodash';
import lI from 'lodash-inflection';
import { format as formatDate, } from 'date-fns';

import { filterByModelType, hasChangeFieldValue, } from '../../shared/models/changeField';
import useCollectionSubscription from './useCollectionSubscription';
import useDocumentSubscription from './useDocumentSubscription';

export default function useChangeFields (company, modelType, period, filteredYearMonths) {
  const allChangeFields = useCollectionSubscription(company?.ref.collection('changeFields'), [company?.id]);
  const orderDoc = useDocumentSubscription(modelType && company?.ref.collection('changeFieldOrders').doc(modelType), [company?.id, modelType]);
  const customChangeFields = useMemo(_ => {
    return modelType ? filterByModelType(allChangeFields, modelType) : sortBy(allChangeFields, ['modelType', 'order']);
  }, [allChangeFields, modelType]);
  const savedOrder = orderDoc?.keys;
  const savedHiddenKeys = orderDoc?.hiddenKeys;
  const items = useCollectionSubscription(
    modelType && period && savedHiddenKeys?.length > 0 && company?.ref.collection(lI.pluralize(modelType)).where('period', '==', period),
    [company?.id, modelType, period, savedHiddenKeys?.join(',')],
  );
  const targetItems = useMemo(_ => {
    const targetYearMonths = (filteredYearMonths || []).map(_ => formatDate(_, 'yyyyMM'));
    return targetYearMonths.length > 0 ? items.filter(_ => targetYearMonths.includes(_.yearMonth)) : items;
  }, [items, filteredYearMonths]);
  const hiddenKeys = useMemo(_ => savedHiddenKeys?.filter(k => !hasChangeFieldValue(targetItems, k)), [savedHiddenKeys, targetItems]);
  return useMemo(_ => ({ customChangeFields, savedOrder, hiddenKeys }), [customChangeFields, savedOrder, hiddenKeys]);
};

export function useChangeFieldOrders (company) {
  const allOrders = useCollectionSubscription(company?.ref.collection('changeFieldOrders'), [company?.id]);
  return useMemo(_ => keyBy(allOrders || [], 'id'), [allOrders]);
};
